.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(8px);
  z-index: 11;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal {
  background: #f8f8f8;
  padding: 20px;
  border-radius: 20px;
  corner-shape: superellipse(1.18);
  width: 550px;
  text-align: center;
  position: relative;
}

.closeButton {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 25px;
}

@media (max-width: 480px) {
  .modal {
    width: 80%;
  }
}
